<div class="zesty-modal__backdrop animated fadeIn">
	<div class="zesty-modal__wrapper">
		<div class="zesty-modal">
			<div class="zesty-modal__header">
				<h3 class="zesty-modal__title">{{ data?.title }}</h3>
			</div>
			<div class="zesty-modal__content">
				<p>
					You are about to delete the following
					{{ data?.type === 'deleteOrganization' ? 'Organization' : 'Account' }}:
				</p>
				<div class="zesty-modal__info" [ngSwitch]="data?.type">
					<ng-container [ngSwitch]="data?.type">
						<ng-container *ngSwitchCase="'deleteOrganization'">
							<p><b>Organization name:</b> {{ data?.options['org_name'] }}</p>
							<p><b>Organization ID:</b> {{ data?.options['org_id'] }}</p>
						</ng-container>
						<ng-container *ngSwitchCase="'deleteAccount'">
							<p><b>Organization name:</b> {{ data?.options['company'] }}</p>
							<p><b>Account ID:</b> {{ data?.options['id'] }}</p>
						</ng-container>
					</ng-container>
				</div>
			</div>

			<div class="zesty-modal__actions">
				<button class="zesty-modal__close" (click)="closeEvent()">Close</button>
				<button class="zesty-modal__red-btn" (click)="confirm()">Delete</button>
			</div>
			<ng-container *ngIf="showConfirm">
				<app-show-confirm (confirmed)="onConfirmed($event)"></app-show-confirm>
			</ng-container>
			<ng-container *ngIf="initProcess">
				<app-show-process [process]="processStatus | async"></app-show-process>
			</ng-container>
		</div>
	</div>
</div>
